import { REFRESH } from './types';

const refresh = ({ target }) => (
  {
    type: REFRESH,
    id: target.id,
  }
);

export default refresh;



// WEBPACK FOOTER //
// ./src/actions/Refresh.js